// extracted by mini-css-extract-plugin
export default {"amount":"club-subscription-check-update_component_amount__a7xAR"};